import axios from 'axios'
import uiService from '../services/service.ui'
import { isNil, isObject, extend } from 'lodash'
import { ErrorCodes } from '../models/enums'
import { ErrorModel } from '../models/ErrorModel'
import store from '../store/store._index'
import Cookie from 'vue-cookie'

function addHeadersToRequest(request) {
  request.headers['Accept-Language'] = Cookie.get('locale')
}

export default {
  install(Vue, options) {
    Vue.mixin({
      created: function () {
        const self = this
        self.$uiService = uiService
      }
    })

    const buildError = (data, src) => {
      let instance = new ErrorModel(500, ErrorCodes.FATALERROR, 'Fatal error occurred')
      instance = extend(instance, data)
      // instance.original = src || data

      return instance
    }
    axios.interceptors.request.use(function (config) {
      addHeadersToRequest(config)
      return config
    })
    axios.interceptors.response.use(response => {
      return response
    }, error => {
      console.log('response error', error.response)
      const { response } = error

      var model = null

      if (response.status === 504 || (response.status === -1 && isNil(response.data))) {
        model = buildError({
          status: 500,
          message: 'Connection error',
          code: ErrorCodes.INTERNETDISCONNECTED
        })
      } else if (isObject(response.data)) {
        model = buildError(response.data)
      } else {
        model = buildError({ status: response.status, message: response.message }, response.data)
      }
      return Promise.reject(model)
    })

    store.dispatch('loadConfig')
  }
}
